import {IMiniOrbitCommunicationAdapter} from '../mini-orbit-communication-adapter.interface';
import {IServiceFactoryExtended} from '../../../service-factory-extended.interface';
import {IAutoLoginParams} from '../../../../../common/interfaces/autologin-params.interface';

export class VoidCommunicationAdapter implements IMiniOrbitCommunicationAdapter {
    constructor(private services: IServiceFactoryExtended) {
    }

    onUserKicked(logoutReason: number): Promise<IAutoLoginParams>{
        return Promise.resolve(null);
    }

    openUrlInExternalBrowser = (url: string): void => {
        this.services.logger.error('You are not suppose to call MiniOrbitService.openUrl because orbit is not in the mini mode');
        this.services.window.open(url);
    };

    onSiteLoaded(): void { }
    onAutologinSuccess(): void { }
    onAutologinFailed(): void { }
    openControlCenter(): void { }
}
